module.exports = __webpack_public_path__ + "static/media/DanLister.46f84abd.png";